/**
 * Import files are read fully into memory and parsed client-side, so every
 * import needs an upper bound. Applies whenever a config does not set its
 * own `maxFileSize`.
 */
export const DEFAULT_MAX_IMPORT_FILE_SIZE = 20 * 1024 * 1024; // 20 MB

export const COLUMN_SEPARATOR = '§';
export const LIST_SEPARATOR = ' | ';

export const LOCALE_FORMATS = ['DE', 'EN'] as const;

export const DELIMITER_OPTIONS = [';', ',', ':'] as const;
